import apiFetch from '../apiFetch'

export default function (salesmanId, token) {
  return apiFetch({ endPoint: 'User/Salesman/' + salesmanId, method: 'DELETE', body: null, token: token })
}
